var map = {
	"./01 Miss Shetty Mr Polishetty.avif": 6010,
	"./02 Bedurulanka 2012.avif": 6069,
	"./03 Bhola Shankar.avif": 5213,
	"./04 Jailer.avif": 1342,
	"./05 PS2.avif": 7624,
	"./06 Ravanasura.avif": 3337,
	"./07 Dasara.avif": 8599,
	"./08 Shaakuthalam.avif": 3813,
	"./09 Farzi.avif": 3958,
	"./10 Waltair Veerayya.avif": 760,
	"./11 Varisu.avif": 1713,
	"./12 Godfather.avif": 2767,
	"./13 The Warrior.avif": 3858,
	"./14 Cobra.avif": 4970,
	"./15 Bimbisara.avif": 4325,
	"./16 Vikram.avif": 609,
	"./17 9 Hours.avif": 2170,
	"./18 Sarkaru Vaari Paata.avif": 2923,
	"./19 RRR.avif": 2555,
	"./20 Bhemla Nayak.avif": 1019,
	"./21 Bangarraju.avif": 6520,
	"./22 Syam Singa Roy.avif": 7145,
	"./23 Pushpa.avif": 8820,
	"./24 Raja Raja Chora.avif": 7566,
	"./25 Wild Dog.avif": 6021,
	"./26 Natyam.avif": 4625,
	"./27 Uppena.avif": 1158,
	"./28 Nishabdham.avif": 8577,
	"./29 Syeraa.avif": 7934,
	"./30 Dear Comrade.avif": 6283,
	"./31 Evaru.avif": 7346,
	"./32 Maharshi.avif": 3318,
	"./33 NTR.avif": 4114,
	"./34 RX 100.avif": 6868,
	"./35 Kaala.avif": 7568,
	"./36 Kayamkulam Kochunni.avif": 5896,
	"./37 Baahubali 2.avif": 6907,
	"./38 Brahmotsawam.avif": 1882,
	"./39 Baahubali.avif": 7950
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3960;